<div class="layout-wrapper" [ngClass]="{'layout-menu-slim': slimMenu,
'layout-menu-overlay': overlayMenu,
'layout-menu-static': staticMenu,
'layout-menu-static-inactive': staticMenuInactive,
'layout-menu-overlay-active': overlayMenuActive,
'layout-menu-active': mobileMenuActive}">

  <app-http-spinner></app-http-spinner>

  <app-topbar></app-topbar>

  <div class="layout-main">
    <app-menu [reset]="resetSlim"></app-menu>

    <div class="layout-content">
      <router-outlet></router-outlet>
      <div ui-view></div>
    </div>
  </div>

  <app-connect *ngIf="user?.enableConnect" [displayDialog]="showConnect" (handler)="receiveConnectMessageHandler($event)" (notificationHandler)="receiveConnectNotification($event)"></app-connect>

  <app-support-chat *ngIf="user?.enableSupport" [displayDialog]="showSupport" (handler)="receiveSupportMessageHandler($event)"
                    (notificationHandler)="receiveSupportNotification($event)"></app-support-chat>

  <app-footer *ngIf="defaultView"></app-footer>

  <div *ngIf="mobileMenuActive" class="layout-mask"></div>
</div>


<p-dialog [(visible)]="displaySsoIdleWarningDialog" header="Session Idle Warning">
  <div>
    Your session has been idle for a while. You can extend the session by clicking the button below.
  </div>
  <div style="margin-top:10px;">
    Unless you extend the session, you will be logged out automatically in
  </div>

  <div style="margin-top:10px;text-align:center">
    <countdown #ssoIdleWarningCountdown [config]="ssoIdleWarningCountdownConfig" class="countdown-min" (event)="handleCountDownEvent($event)">
    </countdown>
  </div>

  <p-footer>
    <div style="margin-top:10px;">
      <button pButton type="text" class="button-inaction" icon="fa fa-close" label="Logout" (click)="onClickLogout()"></button>
      <button pButton type="text" class="button-inaction" icon="fa fa-cross" label="Close" (click)="displaySsoIdleWarningDialog=false"></button>
      <button pButton type="text" class="button-action" icon="fa fa-check" label="Extend" (click)="onClickExtendSession()"></button>
    </div>
  </p-footer>
</p-dialog>


<p-dialog [(visible)]="displaySsoMaxWarningDialog" header="Session Timeout Warning">
  <div>
    You have reached the maximum time allowed for a single session.
  </div>
  <div style="margin-top:10px;">
    Please save your work!!
  </div>
  <div style="margin-top:10px;">
    For security reasons, you will be logged out automatically in
  </div>
  <div style="margin-top:10px;text-align:center">
    <countdown #ssoMaxWarningCountdown [config]="ssoMaxWarningCountdownConfig" class="countdown-min" (event)="handleCountDownEvent($event)">
    </countdown>
  </div>

  <p-footer>
    <div style="margin-top:10px;">
      <button pButton type="text" class="buton-inaction" icon="fa fa-close" label="Logout" (click)="onClickLogout()"></button>
      <button pButton type="text" class="button-action" icon="fa fa-check" label="Close" (click)="displaySsoMaxWarningDialog=false"></button>
    </div>
  </p-footer>
</p-dialog>
